import React, { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import api from "@/lib/api";
import ConfirmDialog from "@/components/ConfirmDialog";
import EaImportPanel from "@/components/energy-analytics/EaImportPanel";
import EaCurveImport from "@/components/energy-analytics/EaCurveImport";
import EaGasDailyImport from "@/components/energy-analytics/EaGasDailyImport";
import EaOpenClient from "@/components/energy-analytics/EaOpenClient";
import EaActivationRequests from "@/components/energy-analytics/EaActivationRequests";
import { AdminSustainability } from "./AdminEaSustainability";

export default function AdminEnergyAnalytics() {
  const [companies, setCompanies] = useState([]);
  const [cid, setCid] = useState(() => sessionStorage.getItem("ea_admin_company") || "");
  const [confirm, setConfirm] = useState(null);
  useEffect(() => { api.get("/companies").then(({ data }) => setCompanies(data)).catch(() => {}); }, []);
  useEffect(() => { sessionStorage.setItem("ea_admin_company", cid); }, [cid]);
  const company = companies.find((c) => c.id === cid) || null;
  const askConfirm = (what, run) => setConfirm({
    title: "Confermi l'importazione?",
    message: `Stai importando ${what} sul cliente: ${company?.name}. I dati verranno associati a questo cliente.`,
    confirmLabel: `Importa su ${company?.name}`,
    variant: "primary",
    onConfirm: () => { run(); },
  });
  return (
    <div className="space-y-6" data-testid="admin-energy-analytics">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">Gestione Energy Analytics</h1>
        <p className="text-sm text-slate-500 mt-1">Seleziona il cliente su cui lavori: tutte le importazioni e le impostazioni sotto riguardano quel cliente.</p>
      </div>
      <EaActivationRequests />
      <div className="sticky top-0 z-20 card-elevated p-4 flex flex-wrap items-center gap-3 border-2 border-blue-200" data-testid="ea-admin-company-bar">
        <Building2 size={18} className="text-blue-700" />
        <span className="text-sm font-semibold text-slate-700">Cliente su cui stai lavorando</span>
        <select value={cid} onChange={(e) => setCid(e.target.value)} className="h-10 rounded-lg border border-slate-300 bg-white px-3 text-sm font-semibold min-w-[320px]" data-testid="ea-admin-company">
          <option value="">Seleziona cliente…</option>
          {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        {!company && <span className="text-xs text-amber-700">Seleziona un cliente per abilitare le importazioni</span>}
      </div>
      <EaOpenClient company={company} />
      <EaImportPanel company={company} askConfirm={askConfirm} />
      <EaCurveImport company={company} askConfirm={askConfirm} />
      <EaGasDailyImport company={company} askConfirm={askConfirm} />
      <AdminSustainability companyId={cid} />
      <ConfirmDialog state={confirm} onClose={() => setConfirm(null)} />
    </div>
  );
}
